<template>
    <!-- meta值 -->
    <div></div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { getWXConfig } from "@/assets/js/weixinShare";

export default {
    props: ["nunber"],
    data() {
        return {};
    },
    asyncData({ store }) {
        // console.log(store, 33333)
        let dataJSON = {
            type: this.nunber,
            only_meta: 1,
        };
        return store.dispatch("pageHistory/getHistory", [dataJSON, () => {}]);
    },
    computed: {
        ...mapGetters({
            getIsLoadIng: "pageHistory/getIsLoadIng",
            getData: "pageHistory/getData",
        }),
    },
    methods: {
        ...mapActions({
            getHistory: "pageHistory/getHistory",
        }),
        filteData() {
            // 微信分享功能+title
            let dome = this.$store.state["pageHistory"]["data"];
            document.title = dome.meta ? dome.meta.title : "";
            let head = document.getElementsByTagName("head");
            if (!document.querySelector("meta[name=description]")) {
                let meta = document.createElement("meta");
                meta.name = "description";
                meta.content = dome.meta ? dome.meta.description : "";
                head[0].appendChild(meta);
            } else {
                document
                    .querySelector("meta[name=description]")
                    .setAttribute(
                        "content",
                        dome.meta ? dome.meta.description : ""
                    );
            }
            window.AFedWxShareData = {
                title: dome.meta ? dome.meta.shareTitle : "",
                imgUrl:
                    dome.meta.pic ||
                    "https://pubunder.artron.net/pubimgs/m/wxImgAuc.png",
                desc: dome.meta.description || "",
                link: window.location.href,
            };
            getWXConfig(window.AFedWxShareData);
        },
    },
    mounted() {
        if (!this.getIsLoadIng) {
            this.getHistory([
                { type: this.nunber, only_meta: 1 },
                () => {
                    this.filteData();
                },
            ]);
        } else {
            // console.log("服务端调用",this.param);
            this.filteData();
        }
    },
};
</script>

<style>
</style>